import { Layout } from "antd";
import { Locale } from 'antd/es/locale';
import React, { useState } from "react";
import { Trans } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import menuItems, { IRoute, theRoutes } from 'src/Components/Menus/menuItems';
import appConfig from 'src/config';
import ThemeProvider from 'src/ThemeProvider';
import './App.css';
import MyHeader from "./MyHeader";

const {Content, Footer} = Layout;

const App: React.FC = () => {

    const [ locale, setLocale ] = useState<Locale>();
    const [ activePage, setActivePage ] = useState(menuItems[0]);

    return (
        <div className={"App"}>
            <ThemeProvider>
                <Layout style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                    <MyHeader onLanguageChange={setLocale}
                              setActivePage={setActivePage}></MyHeader>
                    <div className="content-container">
                        <Content className={"content"}>
                            <Routes>
                                {theRoutes.map((page: IRoute, index: number) => (
                                    <Route key={index} path={page.key} element={page.reactElement}/>
                                ))}
                            </Routes>
                        </Content>
                    </div>
                    <Footer className="myFooter">
                        Backend {appConfig.env} - API {appConfig.apiURL} - <Trans i18nKey={"Copyright"}/>
                    </Footer>
                </Layout>
            </ThemeProvider>
        </div>
    );
};

export default App;
